import React from 'react';
import { Chip } from '@mui/material';
import { getPaymentChip, getPaymentChipForCategory } from '../../utils/payment';
import PayPalIcon from './PayPalIcon';

/**
 * Einheitlicher Zahlungs-Chip für Fahrt-Listen (LiveMap, Fahrtenverwaltung,
 * Berichte). Leitet Label/Farbe aus der gemeinsamen Ableitung (utils/payment)
 * ab und blendet bei reinen Fahrzeug-Fahrten standardmäßig nichts ein (null).
 *
 * Entweder `ride` übergeben (Ableitung aus paymentMethod/paymentStatus) oder
 * `category` (bereits abgeleitet, z. B. Berichts-Zeilen mit paymentCategory).
 */
const PaymentChip = ({ ride, category, showInVehicle = false, sx }) => {
  const chip = category != null
    ? getPaymentChipForCategory(category, { showInVehicle })
    : getPaymentChip(ride, { showInVehicle });
  if (!chip) return null;
  return (
    <Chip
      label={chip.label}
      size="small"
      color={chip.color}
      variant={chip.variant}
      icon={chip.paypalIcon ? <PayPalIcon /> : undefined}
      sx={sx}
    />
  );
};

export default PaymentChip;
